import React, { useState } from 'react';
import { Dialog } from '@base-ui-components/react/dialog';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';


// Component for sites full instructions (using component "Dialog" from react libraries)

export default function InstructionsDialog() {
  const isMobile = window.innerWidth <= 768;
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Dialog.Root>
      <Dialog.Trigger 
        aschild="true"
        variant="contained"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
                border: 'none',
                backgroundColor: '#D9D9D9',
                color: '#000000',
                borderRadius: '10px',
                fontFamily: 'Finlandica-Bold, sans-serif',
                fontWeight: '200',
                lineHeight: '20px',
                fontSize: '20px',
                padding: '6px 16px',
                boxShadow: 'none',
                textTransform: 'none',
                width: '100%',
                maxWidth: '290px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 0.2s ease-in-out'

          }}
      >
          {<InfoOutlineIcon style={{ fontSize: 30, color: "#000000"}} />}
          Sivun käyttöohjeet
          {<ArrowForwardIosIcon style={{ fontSize: 18, color: "#000000"}} />}
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Backdrop style={{position: 'fixed', inset: 0 }} />
        <div style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}>
          <Dialog.Popup
            style={{
              position: 'relative',
              backgroundColor: '#FFFFFF',
              padding: '32px',
              paddingTop: '0',
              borderRadius: '12px',
              width: '90%',
              fontFamily: 'Finlandica, sans-serif',
              fontSize: isMobile ? '16px' : '20px',
              lineHeight: '22px',
              color: '#000000',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
              maxHeight: '90vh',
              maxWidth: '100vh',
              overflowY: 'auto',

            }}
          >
            <Dialog.Close 
              aschild="true"
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
                >
                  <CloseIcon style={{ fontSize: 24, color: '#000000' }} />
            </Dialog.Close>
            <Dialog.Title style={{ fontSize: '26px', fontWeight: '600', marginBottom: '16px', fontFamily: 'Sisu-Regular', letterSpacing: '1px' }}>
              Sivun käyttöohjeet
            </Dialog.Title>
            <Dialog.Description aschild="true" style={{fontFamily: 'Finlandica-Regular, sans-serif'}}>
                <strong>1.</strong> Saat näkyviin hankkimasi liput painamalla nuolta ottelutietojen vierestä.<br /><br />
                <strong>2.</strong> Oletuksena jokaisen lipun kohdalla näkyy tilaajan sähköpostiosoite. Voit korvata sen kirjoittamalla lipun käyttäjän sähköpostiosoitteen kenttään 
                ja painamalla sitten "Tallenna muutokset". Voit myös tyhjentää sähköpostiosoitteen, mikäli et itse käytä kyseistä lippua, eikä sinulla ole antaa lipun käyttäjän sähköpostiosoitetta.<br /><br />
                <em>Huom!</em> Varmista, että sinulla on lipun käyttäjän suostumus antaa hänen sähköpostiosoitteensa. Lasten lippujen osalta, täytä kenttään aikuisen sähköpostiosoite.<br /><br />
                <strong>3.</strong> Voit muokata tietoja ennen ottelua sekä 7 päivän ajan ottelun jälkeen. Tämän jälkeen tietojen muuttaminen ei enää ole mahdollista.<br /><br />
                Voit lukea asiakastietojen käsittelystä <a href="https://www.palloliitto.fi/tietosuoja/asiakastietojen-tietosuojaseloste" target="_blank" rel="noopener noreferrer">tietosuojaselosteestamme</a>.
            </Dialog.Description>      
          </Dialog.Popup>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
